// 超过iphone6尺寸时，以iphone6尺寸显示
function rem (opt) {
  var s = window.document
  var r = s.documentElement
  var tb = 60
  var minf = 10
  var maxf = 10
  var m = (opt && opt.mode) || 'normal'
  var sw = (opt && opt.width) || 320
  var sh = (opt && opt.height) || 508
  var mw = sw / minf * maxf
  var bei = sw / minf
  var mf = minf
  if (sw > 320) {
    mf = 320 / bei
  }
  var normalInit = function (m, r, w) {
    if (w >= mw) {
      r.style.fontSize = maxf + 'px'
    } else {
      if (w <= 320) {
        r.style.fontSize = mf + 'px'
      } else {
        r.style.fontSize = w / bei + 'px'
      }
    }
  }
  var fullPageInit = function (m, r, w) {
    var h = r.clientHeight
    var fs = minf
    var k = sh / sw
    if (w >= mw) {
      fs = maxf
    } else {
      if (w <= 320) {
        fs = mf
      } else {
        fs = w / bei
        console.log(w, sw, bei, fs)
      }
    }
    if (w <= sw) {
      if (w * k >= h) {
        fs = h / sh * fs
      } else {
        fs = w / sw * fs
      }
    } else {
      if (w > sw && w < mw) {
        if (w * k >= h) {
          fs = h / (w * k) * fs
        } else {
          fs = fs
        }
      } else {
        if (w * k > h && h <= mw * k) {
          fs = h / (mw * k) * fs
        } else {
          fs = fs
        }
      }
    }
    r.style.fontSize = fs + 'px'
  }
  var init = function (m, r) {
    var w = r.getBoundingClientRect().width
    switch (m) {
      case 'normal':
        normalInit(m, r, w)
        break
      case 'fullpage':
        fullPageInit(m, r, w)
        break
      default:
        break
    }
  }
  window.addEventListener('resize',
    function () {
      init(m, r)
    })
  init(m, r)
}
/**
  * @explain     : 信用卡还款项目rem设置
  * @created by  : alicelbliu
  * @created on  : 2017.03.01
*/
console.log(rem)
rem({
  mode: 'normal', // mode(模式)：fullpage(满屏) || normal(超过一屏，默认)
  width: 375, // width(设计稿宽度): int(px尺寸，默认320)
  height: 603 // height(设计稿高度,去掉black bar之后的高度): int(px尺寸，默认508)
})



// WEBPACK FOOTER //
// ./src/assets/js/rem_min.js